import { ORDER_TIME_OPTIONS } from '../../../../../modals/order-method/useOrderTimeOptions';
import { DropoffAction, ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  sections: {
    order_method: {
      titles: {
        [ORDER_METHODS.PICKUP]: 'Ritiro',
        [ORDER_METHODS.DELIVERY]: 'Consegna',
        [ORDER_METHODS.ROOM_SERVICE]: {
          [RoomServiceLocationType.RoomService]: 'Room service',
          [RoomServiceLocationType.TableService]: 'Servizio al tavolo',
        },
      },
    },
    delivery_info: {
      title: 'Dettagli consegna',
      on_arrival: "All'arrivo:",
    },
    customer_info: {
      title: 'Contatto',
    },
    payment: {
      title: 'Pagamento',
    },
    request_invoice: {
      title: 'Richiedi fattura',
      form: {
        is_receipt_required: {
          label: 'Richiedi fattura via email',
        },
      },
    },
    location: {
      title: 'Indirizzo negozio',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Indirizzo di consegna',
      },
      [ORDER_METHODS.ROOM_SERVICE]: {
        title: 'Indirizzo in loco',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Indirizzo di ritiro',
      },
    },
    method: {
      title: 'Metodo',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Consegna',
      },
      [ORDER_METHODS.ROOM_SERVICE]: {
        title: 'In loco',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Ritiro',
      },
    },
    time: {
      title: 'Orario',
      method: {
        [ORDER_TIME_OPTIONS.asap]: {
          title: 'Standard {{time}} min, Oggi',
        },
        [ORDER_TIME_OPTIONS.scheduled]: {
          title: 'Pianifica per dopo',
        },
      },
    },
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Numero camera',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Numero tavolo',
  },
  form: {
    dropoff_action: {
      options: {
        [DropoffAction.RingDoorBell]: 'Suona il campanello',
        [DropoffAction.Sms]: "Contattami via SMS all'arrivo",
      },
    },
    doorbell_name: {
      placeholder: 'Nome campanello (opzionale)',
    },
    company_name: {
      placeholder: 'Nome azienda (opzionale)',
    },
    customer_note: {
      placeholder: 'Hai una nota per il ristorante?',
    },
  },
  buttons: {
    change: 'Modifica',
    edit: 'Modifica',
    done: 'Fatto',
    add_delivery_note: '+ Aggiungi dettagli consegna',
    add_order_note: "+ Aggiungi nota all'ordine",
  },
  summary: {
    doorbell: 'Campanello',
    company: 'Azienda',
    note: "Nota dell'ordine",
  },
};
